import React from "react";
import NavbarAuth from "../parts/NavbarAuth";

const Auth = ({ title, children, width = "420px", ...props }) => {
  window.document.title = title
    ? `${title} - Enabled By Design`
    : "Enabled By Design";
  return (
    <div className="lAuth">
      <NavbarAuth {...props} />
      <div className="lAuth_container">
        <main style={{ width }}>{children}</main>
      </div>
    </div>
  );
};

export default Auth;
